export const RETURN_STATUS = {
  REQUESTED: 'requested',
  RETURNED: 'returned',
  DENIED: 'denied',
};
